<template>
  <div class="regist">
    <div class="form">
      <van-form ref="registForm" show-error show-error-message>
        <van-field v-model="registInfo.name" label="姓名" name="name" placeholder="请输入姓名" :rules="rules.name"
          @blur="handleBlur" />
        <van-field v-model="registInfo.idNo" label="身份证号" name="idNo" maxlength="18" placeholder="请输入身份证号"
          :rules="rules.idNo" @blur="handleBlur" />
        <van-field v-model="registInfo.bankCardNo" label="银行卡号" type="digit" name="bankCardNo" placeholder="请输入银行卡号"
          :rules="[{ required: true }]" @blur="handleBlur" />

        <van-field v-model="registInfo.mobile" label="手机号" name="mobile" maxlength="11" placeholder="请输入银行卡预留手机号"
          :rules="rules.mobileRules" @blur="handleBlur" />

        <van-field v-model="registInfo.verifyCode" center clearable name="verifyCode" label="验证码" type="digit"
          maxlength="6" placeholder="请输入验证码" :rules="[{ required: true }]" @blur="handleBlur">
          <template #button>
            <van-button :class="[
              'send-verifyCode',
              verifyCodeSeconds > 0 ? 'disabled' : '',
            ]" color="#FF6F00" round plain size="small" type="primary" native-type="button" @click="sendVerifyCode"
              :disabled="verifyCodeSeconds > 0">{{
                verifyCodeSeconds > 0 ? verifyCodeSeconds + 's' : '发送验证码'
              }}</van-button>
          </template>
        </van-field>

        <van-field v-model="registInfo.bankOpen" class="unionpayNo" label="开户行" name="bankOpen" right-icon="arrow"
          placeholder="请选择开户行" readonly @click-input="changeBank" :rules="[{ required: true }]" @focus="handleFocus"
          @blur="handleBlur">
          <template #input v-if="registInfo.bankOpen">
            <div>{{ registInfo.bankOpen }}</div>
            <div>{{ registInfo.unionpayNo }}</div>
          </template>
        </van-field>

        <van-field v-model="registInfo.businessNatureName" label="经营性质" right-icon="arrow" readonly
          name="businessNatureName" placeholder="请选择经营性质" @click-input="manageShow = true" :rules="[{ required: true }]"
          @focus="handleFocus" @blur="handleBlur" />

        <van-action-sheet v-model="manageShow" :actions="manageType" @select="onSelect" />
        <van-field v-model="registInfo.email" label="邮箱" placeholder="请输入邮箱" name="email" :rules="rules.email"
          @blur="handleBlur" />

        <van-field v-model="registInfo.address" maxlength="50" label="居住地址" name="address" placeholder="仅需要填写粗略地址"
          :rules="[{ required: true }]" @blur="handleBlur" />
      </van-form>
    </div>

    <div class="footer">
      <div class="radio">
        <van-checkbox @click="checkedChange" :value="checked" checked-color="#FF6F00">已阅读并同意
          <a :href="latitude ? '/wicmp-app-h5/#/privacyAgreementDetails' : '/h5-app-sh/#/agreement?aType=privacy'"
            style="color: #FF6F00">《隐私条款》</a></van-checkbox>
      </div>

      <van-button size="large" round :loading="loading" :disabled="!checked" color="#FF6F00" @click="handleRegist"
        text="注册为万达个体商户" />
    </div>
  </div>
</template>

<script>
import { apiGetVerifyCode, apiPostUserRegist, apiGetInfo_userId } from '@/api/dq';
import { rules } from './hooks';
import * as types from '@/store/mutation-types';
// <!-- 56:直营57:代理58:加盟83:直营+代理91:直营+加盟 -->
const manageType = [
  { name: '直营', value: 56 },
  { name: '代理', value: 57 },
  { name: '加盟', value: 58 },
  { name: '直营+代理', value: 83 },
  { name: '直营+加盟', value: 91 },
];
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
export default {
  name: 'regist',
  computed: {
    latitude() {
      return localStorage.getItem('latitude')
    }
  },
  data() {
    return {
      name: '',

      rules,
      checked: false,
      registInfo: {
        // 用户名
        name: '',
        // 省份证号
        idNo: '',

        // 银行卡号
        bankCardNo: '',

        // 手机号
        mobile: '',
        // 验证码
        verifyCode: '',
        // 开户行
        bankOpen: '',
        // 银联号
        unionpayNo: '',
        // 经营性质
        businessNature: '',
        businessNatureName: '',

        // 邮箱
        email: '',
        // 居住地址
        address: '',

        channel: '0',
      },

      manageShow: false,
      manageType,
      verifyCodeSeconds: 0,
      timer: 0,
      disabled: true,
      loading: false,
    };
  },
  methods: {
    checkedChange() {
      this.checked = !this.checked;
    },
    sendVerifyCode() {
      this.$refs.registForm
        .validate('mobile')
        .then(() => {
          if (this.verifyCodeSeconds === 0) {
            this.verifyCodeSeconds = 60;
            apiGetVerifyCode(this.registInfo.mobile);
          } else return;
          this.timer = setInterval(() => {
            this.verifyCodeSeconds--;
            if (this.verifyCodeSeconds <= 0) {
              this.verifyCodeSeconds = 0;
              clearInterval(this.timer);
              return;
            }
          }, 1000);
        })
        .catch((err) => err);
    },
    handleFocus() {
      document.activeElement.blur();
    },
    handleBlur() {
      window.scroll(0, 0)
    },
    changeBank() {
      localStorage.setItem('registInfo', JSON.stringify(this.registInfo));
      this.$router.push({
        path: '/dq/bankList',
      });
    },
    onSelect(e) {
      this.registInfo.businessNatureName = e.name;
      this.registInfo.businessNature = e.value;
      this.manageShow = false;
    },
    handleRegist() {
      this.$refs.registForm
        .validate()
        .then(() => {
          const form = new FormData();
          for (const key in this.registInfo) {
            form.append(key, this.registInfo[key]);
          }
          let openId = localStorage.getItem('dq_openId')
          if (!openId || openId == 'null' || openId == 'undefined') {
            openId = ''
          }
          form.append('openId', isWechat() ? openId : '');
          this.loading = true;
          apiPostUserRegist(form).then((res) => {
            console.log('****res******', res);
            this.loading = false;
            if (res.status !== 200) return this.$toast(res.message);

            if (isWechat()) {
              this.$router.replace({ path: '/dq/registSuccess', query: { mobile: this.registInfo.mobile } });
            } else {
              apiGetInfo_userId(res.data).then(userInfo => {
                console.log('******userInfo******', userInfo);
                this.$store.commit('base/setUserInfo', userInfo.data);
                let base = JSON.stringify({
                  token: localStorage.getItem('dq_token'),
                  userId: userInfo.data.id,
                });
                this.$store.commit(`account/${types.ACCOUNT_USER_ID}`, userInfo.data.id);
                window.location.href = `${window.location.origin}${window.location.pathname}#/dq/business_choice?token=${localStorage.getItem('dq_token')}`;
              })
            }

          });
        })
        .catch(() => {
          this.$toast('请填写完整信息');
        });
    },
  },
  mounted() {
    if (localStorage.getItem('registInfo')) {
      let registInfo = JSON.parse(localStorage.getItem('registInfo'));
      for (const key in registInfo) {
        this.registInfo[key] = registInfo[key];
      }
    } else {
      this.registInfo.mobile = this.$route.query.mobile
    }
  },
};
</script>

<style lang="less" scoped>
@import url('./dq.global.less');

.regist {
  line-height: 1;
  display: flex;
  flex-direction: column;

  .form {
    flex: 1;
    overflow: auto;
  }

  .footer {
    padding: 12px;
    box-sizing: border-box;

    .radio {
      margin-bottom: 6px;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;

      /deep/.van-checkbox__icon {
        font-size: 16px;
      }
    }
  }
}

.address-label {
  font-size: 14px;
  line-height: 24px;
  padding: 10px 16px 0;
}

.address-value {
  /deep/.van-cell__value {
    background: #f5f5f5;
    border-radius: 6px;
    padding: 4px;
  }
}

.unionpayNo {
  /deep/.van-field__control--custom {
    display: block;
  }
}

.send-verifyCode {
  width: 84px;
}

.disabled {
  color: rgb(105, 102, 102) !important;
  border-color: rgb(105, 102, 102) !important;
}
</style>